export default __webpack_public_path__ + "static/media/oh-baby.7e4a1413.gif";